import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import BaseRoute from './base-route.gjs';
import Component from '@glimmer/component';
import ConversationMemberListItem from '../conversation-member-list-item.gjs';
import GhostButton from 'ember-simplepractice/components/spds/action/button/ghost';
import styles from './previous-members.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class MessagingRoutesPreviousMembers extends Component {
  @service messagingNavigation;

  get routeHandler() {
    return this.args.handler;
  }

  get members() {
    return this.routeHandler.members;
  }

  onNameClickFor = member => {
    const profileMember = member.isCouple ? member.members?.[0] : member;
    if (!profileMember || !this.routeHandler.canNavigateToClientProfile(profileMember)) {
      return undefined;
    }

    return () => {
      document.activeElement.blur();
      this.routeHandler.navigateToClientProfile.perform(profileMember);
    };
  };

  goBack = async () => {
    await this.messagingNavigation.leaveChildRoute();
  };

  <template>
    <BaseRoute class="{{styles.component}} previous-members-page" data-test-previous-members-route>
      <:header>
        <GhostButton
          @fitContent={{true}}
          @iconOnly={{true}}
          {{on "click" this.goBack}}
          class="back-button"
          data-test-previous-members-page-back-button
        >
          {{svgJar "messaging-chevron-left"}}
        </GhostButton>

        <span class="title">{{t "emc.conversation_details.previous_members_title"}}</span>
      </:header>
      <:default>
        <div class="members-section-header" data-test-members-section-header>
          <h2 class="members-section-title" data-test-members-section-title>
            {{t "emc.conversation_details.members_section" count=this.members.length}}
          </h2>
        </div>

        <ul class="members-list" data-test-members-list role="list">
          {{#each this.members as |member|}}
            <ConversationMemberListItem
              @member={{member}}
              @onNameClick={{this.onNameClickFor member}}
            />
          {{/each}}
        </ul>
      </:default>
    </BaseRoute>
  </template>
}
